import React from 'react'
import Portal from '../../../../component/portal'
import { AppContext } from '../../../../config/context'
import { getLocalChannelId, safeParse, goToHref } from '../../../../common/util'
import ee, { EVENT_LANG_CHANGE } from '../../../../common/util/event'

const MESSAGE_CLIENT_HEIGHT = 'CLIENT_HEIGHT'
const MESSAGE_REDIRECT = 'MESSAGE_REDIRECT'
const MESSAGE_USER_LANG = 'USER_LANG'
const MESSAGE_VIEWPORT_INFO = 'VIEWPORT_INFO'

class ActivityFrame extends React.Component {
    constructor() {
        super(...arguments)
        const { lang } = this.context.user
        const pid = getLocalChannelId()
        const frameSrc = window._inject_app_data_.frameSrc
        this.state = {
            frameSrc: `${frameSrc}${frameSrc.indexOf('?') > 0 ? '&' : '?'}lang=${lang}&pid=${pid}`,
            frameHeight: '973'
        }
        this.frameTarget = null
    }

    componentDidMount() {
        window.addEventListener('message', this.messageHandler)
        window.addEventListener('scroll', this.onViewportChange)
        window.addEventListener('resize', this.onViewportChange)
        ee.addListener(EVENT_LANG_CHANGE, this.postUserLang)
    }

    onViewportChange = () => {
        const height = window.innerHeight
        const top = document.documentElement.scrollTop
        this.frameTarget.contentWindow.postMessage(JSON.stringify({ type: MESSAGE_VIEWPORT_INFO, data: { height, top } }), '*')
    }

    messageHandler = message => {
        const messageData = safeParse(message.data)
        if (!messageData) {
            return
        }
        const { type, data } = messageData
        if (type === MESSAGE_CLIENT_HEIGHT) {
            this.setState({
                frameHeight: data.height + ''
            })
        } else if (type === MESSAGE_REDIRECT) {
            goToHref(data.href, data.target)
        } else if (type === MESSAGE_VIEWPORT_INFO) {
            this.onViewportChange()
        }
    }

    postUserLang = lang => {
        this.frameTarget.contentWindow.postMessage(JSON.stringify({ type: MESSAGE_USER_LANG, data: { lang } }), '*')
    }

    render() {
        const { frameSrc, frameHeight } = this.state
        return <div>
            <iframe src={frameSrc} width='100%' height={frameHeight} frameBorder='0' scrolling='0' style={{ display: 'block' }} ref={dom => this.frameTarget = dom}></iframe>
        </div>
    }
}

ActivityFrame.contextType = AppContext
export default Portal(ActivityFrame, 'frame-page-container')